import React, { useEffect } from "react";
import "./sihirLanding.css";

const APP_STORE_URL = "https://apps.apple.com/app/id6478240257";
const SUPPORT_EMAIL = "testtmeapp@gmail.com";
const LAST_UPDATED = "21 Eylül 2026";

const TOC = [
  { id: "kapsam", label: "Kapsam" },
  { id: "veriler", label: "Toplanan veriler" },
  { id: "kullanim", label: "Kullanım amaçları" },
  { id: "dayanak", label: "Hukuki dayanak" },
  { id: "ucuncu", label: "Üçüncü taraflar" },
  { id: "reklam", label: "Reklam ve izleme" },
  { id: "cerez", label: "Çerezler" },
  { id: "saklama", label: "Saklama" },
  { id: "haklar", label: "Hakların" },
  { id: "silme", label: "Hesap silme" },
  { id: "cocuklar", label: "Çocuklar" },
  { id: "iletisim", label: "İletişim" },
];

export default function SihirDefteriPrivacy() {
  useEffect(() => {
    document.title = "Gizlilik Politikası — Sihir Defteri";
    return () => {
      document.title = "Sihir Defteri — Kişisel yansıma defteri";
    };
  }, []);

  return (
    <div className="sd-landing">
      <div className="sd-atmosphere" aria-hidden="true" />
      <div className="sd-shell">
        <header className="sd-nav">
          <a className="sd-nav__brand" href="/">
            Sihir Defteri
          </a>
          <nav className="sd-nav__links" aria-label="Ana">
            <a className="sd-hide-sm" href="/">
              Ana sayfa
            </a>
            <a className="sd-nav__cta" href={APP_STORE_URL} target="_blank" rel="noreferrer">
              App Store
            </a>
          </nav>
        </header>

        <main className="sd-legal" id="top">
          <p className="sd-overline">Yasal</p>
          <h1>Gizlilik politikası</h1>
          <p className="sd-legal__lead">
            Sihir Defteri kişisel bir yansıma alanıdır. Bu metin, uygulamada ve bu sitede hangi
            verilerin neden işlendiğini, kimlerle paylaşıldığını ve haklarını nasıl
            kullanabileceğini açıklar.
          </p>
          <p className="sd-legal__meta">Son güncelleme: {LAST_UPDATED}</p>

          <nav className="sd-legal__toc" aria-label="İçindekiler">
            {TOC.map((item) => (
              <a key={item.id} href={`#${item.id}`}>
                {item.label}
              </a>
            ))}
          </nav>

          <section id="kapsam">
            <h2>1. Kapsam ve veri sorumlusu</h2>
            <p>
              Bu politika; Sihir Defteri iOS ve Android uygulamasını, bu tanıtım sitesini ve bunlara
              bağlı destek kanallarını kapsar. Hizmeti işleten ve 6698 sayılı Kişisel Verilerin
              Korunması Kanunu (KVKK) kapsamında veri sorumlusu sıfatını taşıyan taraf, Sihir
              Defteri / Testtme’dir.
            </p>
            <p>
              Taleplerin için: <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
            </p>
          </section>

          <section id="veriler">
            <h2>2. Topladığımız veriler</h2>
            <p>Yalnızca hizmeti sunmak için gereken verileri işleriz.</p>

            <h3>Hesap</h3>
            <ul>
              <li>Ad, soyad ve görünen ad</li>
              <li>E-posta adresi</li>
              <li>Cep telefonu numarası</li>
              <li>Hesap kimliği, rol (defter sahibi veya rehber) ve oturum bilgisi</li>
            </ul>
            <p>
              Şifren, kimlik doğrulama altyapısında tutulur; bize düz metin olarak ulaşmaz. Kayıt
              sırasında oluşturulan geçici şifre e-postana gönderilir.
            </p>

            <h3>Defter kayıtları</h3>
            <ul>
              <li>Yazdığın metin</li>
              <li>Seçtiğin ruh hali ve konu</li>
              <li>Kayıt tarihi ve ilgili durum bilgileri</li>
            </ul>
            <p>
              Deftere yazmak için reklam izlemek, yapay zekâ kullanmak veya bir rehbere başvurmak
              zorunlu değildir. Kayıtların varsayılan olarak sana aittir.
            </p>

            <h3>İsteğe bağlı bakış açısı</h3>
            <ul>
              <li>
                <strong>Farklı bir bakış açısı (AI):</strong> ilgili kayıttaki metin, ruh hali ve
                konu, yanıt üretmek üzere işlenir.
              </li>
              <li>
                <strong>İnsan rehber:</strong> açıkça istediğinde ilgili kayıt, bakış açısı yazması
                için rehberin görebileceği kuyruğa düşer.
              </li>
            </ul>

            <h3>Bildirimler</h3>
            <p>
              İzin verirsen cihaza ait bir bildirim jetonu (Expo) ve platform bilgisi saklanır.
              Bildirim metinleri kilit ekranında defter içeriğini göstermez.
            </p>

            <h3>Destek ve iletişim</h3>
            <p>
              Bu sitedeki form veya e-posta ile yazdığında ad, e-posta ve mesaj içeriği talebini
              yanıtlamak için işlenir.
            </p>

            <h3>Teknik veriler</h3>
            <p>
              Hizmetin çalışması için sunucu günlükleri, hata kayıtları ve cihaz/uygulama sürümü
              gibi sınırlı teknik bilgiler oluşabilir. Cihazda oturum ve bazı tercihler güvenli
              depolama veya yerel depolamada tutulabilir.
            </p>
          </section>

          <section id="kullanim">
            <h2>3. Verileri nasıl kullanırız</h2>
            <ul>
              <li>Hesabını oluşturmak, oturumunu açmak ve hesabını yönetmek</li>
              <li>Defter kayıtlarını saklamak ve sana göstermek</li>
              <li>İstediğinde AI veya insan rehber bakış açısı üretmek</li>
              <li>İsteğe bağlı bildirim göndermek</li>
              <li>Destek taleplerine yanıt vermek</li>
              <li>
                Güvenliği sağlamak, kötüye kullanımı önlemek ve yasal yükümlülükleri yerine getirmek
              </li>
            </ul>
            <p>Defter içeriğini reklam hedeflemek veya üçüncü taraflara satmak için kullanmayız.</p>
          </section>

          <section id="dayanak">
            <h2>4. Hukuki dayanak (KVKK)</h2>
            <ul>
              <li>
                <strong>Sözleşmenin kurulması ve ifası:</strong> hesap, defter ve temel uygulama
                işlevleri.
              </li>
              <li>
                <strong>Açık rıza:</strong> isteğe bağlı AI bakış açısı, insan rehber, bildirimler,
                reklam ölçümü / App Tracking Transparency.
              </li>
              <li>
                <strong>Meşru menfaat:</strong> güvenliğin sağlanması, spam ve kötüye kullanımın
                önlenmesi, temel hizmet sürekliliği — hak ve özgürlüklerini zedelemeyecek ölçüde.
              </li>
              <li>
                <strong>Hukuki yükümlülük:</strong> saklama, bildirim veya resmi mercilerin talebi
                gibi zorunlu haller.
              </li>
            </ul>
          </section>

          <section id="ucuncu">
            <h2>5. Üçüncü taraflar ve yurt dışı aktarım</h2>
            <p>
              Hizmeti sunmak için aşağıdaki işleyenleri kullanırız. Bunların bir kısmı veriyi
              Türkiye dışındaki sunucularda işleyebilir (özellikle ABD). Aktarım, hizmetin ifası
              ve/veya açık rızan çerçevesinde yapılır.
            </p>
            <ul>
              <li>
                <strong>Google Firebase / Google Cloud:</strong> kimlik doğrulama, veritabanı, bulut
                işlevleri ve bu sitenin barındırılması.
              </li>
              <li>
                <strong>OpenAI:</strong> yalnızca “farklı bir bakış açısı” istediğinde, o kayda ait
                metin, ruh hali ve konu.
              </li>
              <li>
                <strong>Google AdMob:</strong> isteğe bağlı ödüllü reklamlar.
              </li>
              <li>
                <strong>Expo:</strong> bildirim iletimi.
              </li>
              <li>
                <strong>E-posta altyapısı / EmailJS:</strong> hesap şifresi, destek ve iletişim
                formunun iletilmesi.
              </li>
              <li>
                <strong>Apple App Store:</strong> indirme ve mağaza işlemleri; defter içeriğin
                Apple’a gönderilmez.
              </li>
            </ul>
            <p>
              İnsan rehber yalnızca sen talep ettiğinde ilgili kaydı görür. Rehberler bu içeriği
              kendi amaçlarıyla kullanamaz.
            </p>
          </section>

          <section id="reklam">
            <h2>6. Reklamlar ve izleme</h2>
            <p>
              Reklamlar, rehber notunu açmak gibi isteğe bağlı adımlarda görünebilir. Deftere kayıt
              yazmak için reklam zorunlu değildir.
            </p>
            <p>
              iOS’ta App Tracking Transparency izni istenebilir. İzni vermezsen reklamlar
              kişiselleştirilmeden gösterilmeye devam edebilir. Uygulama, reklam isteklerinde
              kişiselleştirilmemiş reklam tercihini kullanacak şekilde yapılandırılmıştır.
            </p>
            <p>
              Bu sitede şu an aktif bir reklam birimi yayınlanmamaktadır. Google Fonts, yazı
              tiplerini yüklemek için kullanılabilir.
            </p>
          </section>

          <section id="cerez">
            <h2>7. Çerezler ve benzeri teknolojiler</h2>
            <p>
              Tanıtım sitesi temel olarak hizmeti sunmak, formu iletmek ve yazı tiplerini yüklemek
              için çalışır. Zorunlu teknik çerezler veya yerel depolama, oturum ve güvenlik için
              kullanılabilir. Pazarlama amaçlı izleme çerezi kullanmıyoruz.
            </p>
          </section>

          <section id="saklama">
            <h2>8. Saklama süresi</h2>
            <ul>
              <li>
                <strong>Hesap ve defter:</strong> hesabın açık olduğu süre boyunca; sildiğinde
                silinir veya kimliksiz hale getirilir.
              </li>
              <li>
                <strong>Destek yazışmaları:</strong> talebi sonuçlandırmak ve yasal süreler için
                gerekli makul süre.
              </li>
              <li>
                <strong>Teknik günlükler:</strong> işletme ve güvenlik için sınırlı süre.
              </li>
            </ul>
            <p>
              Yedeklerde veri, silme işleminden sonra kısa bir süre daha kalabilir; ardından yedek
              döngüsüyle kalkar.
            </p>
          </section>

          <section id="haklar">
            <h2>9. KVKK kapsamındaki hakların</h2>
            <p>KVKK madde 11 uyarınca, veri sorumlusu sıfatıyla bize başvurarak:</p>
            <ul>
              <li>Kişisel verilerinin işlenip işlenmediğini öğrenme</li>
              <li>İşlenmişse buna ilişkin bilgi talep etme</li>
              <li>İşlenme amacını ve amaca uygun kullanılıp kullanılmadığını öğrenme</li>
              <li>Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme</li>
              <li>Eksik veya yanlış işlenmişse düzeltilmesini isteme</li>
              <li>KVKK madde 7 çerçevesinde silinmesini veya yok edilmesini isteme</li>
              <li>
                Düzeltme, silme veya yok etme işlemlerinin aktarıldığı üçüncü kişilere
                bildirilmesini isteme
              </li>
              <li>
                İşlenen verilerin münhasıran otomatik sistemler ile analiz edilmesi suretiyle
                aleyhine bir sonucun ortaya çıkmasına itiraz etme
              </li>
              <li>
                Kanuna aykırı işleme nedeniyle zarara uğraman halinde giderilmesini talep etme
              </li>
            </ul>
            <p>
              Başvurularını <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> adresine yazarak
              iletebilirsin. Kimliğini doğrulayabileceğimiz bilgilerle yazman, talebi doğru kişiye
              bağlamak için gerekir. Yanıt, KVKK’daki süreler içinde verilir.
            </p>
            <p>
              Talebinin reddedildiğini düşünürsen Kişisel Verileri Koruma Kurulu’na şikâyette
              bulunabilirsin.
            </p>
          </section>

          <section id="silme">
            <h2>10. Hesabını ve verilerini silme</h2>
            <p>
              Uygulamada Profil → Hesabımı sil ile hesabını kapatabilirsin. Bu işlem geri alınamaz.
              Kimlik kaydın kaldırılır; oturumun kapanır; defter kayıtların silinir veya kimliksiz
              hale getirilir.
            </p>
            <p>
              Uygulamaya erişemiyorsan aynı talebi {SUPPORT_EMAIL} adresine, kayıtlı e-postandan
              yazabilirsin.
            </p>
          </section>

          <section id="cocuklar">
            <h2>11. Çocuklar</h2>
            <p>
              Sihir Defteri 13 yaşından küçük çocuklara yönelik değildir. 13 yaşından küçük biri
              hesap oluşturmuşsa, ebeveyn veya vasinin bize yazması üzerine hesabı ve ilişkili
              verileri sileriz.
            </p>
          </section>

          <section id="iletisim">
            <h2>12. Değişiklikler ve iletişim</h2>
            <p>
              Bu politikayı hizmet veya yasal yükümlülükler değiştiğinde güncelleyebiliriz. Güncel
              metin her zaman bu sayfada yer alır; önemli değişikliklerde uygulamada veya e-posta
              ile haber veririz.
            </p>
            <p>
              Sihir Defteri / Testtme
              <br />
              E-posta: <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
              <br />
              Web: <a href="/">sihirdefteritarot.testtme.com</a>
            </p>
            <p className="sd-legal__note">
              Bu metin bilgilendirme amaçlıdır; hukuki danışmanlık yerine geçmez.
            </p>
          </section>
        </main>

        <footer className="sd-footer">
          <div>
            <div className="sd-footer__brand">Sihir Defteri</div>
            <div>© {new Date().getFullYear()} · Kişisel yansıma defteri</div>
          </div>
          <nav aria-label="Alt">
            <a href="/privacy">Gizlilik</a>
            <a href={APP_STORE_URL} target="_blank" rel="noreferrer">
              App Store
            </a>
            <a href={`mailto:${SUPPORT_EMAIL}`}>Destek</a>
          </nav>
        </footer>
      </div>
    </div>
  );
}
